import moment from 'moment'

export const isoDateFormat = 'YYYY-MM-DD'

const minDate = moment.utc('2000-01-01', isoDateFormat)
const maxDate = moment.utc('2099-01-01', isoDateFormat)

export function isAfterToday(date: string): boolean {
    let today = moment().format(isoDateFormat)
    return moment(date).isAfter(today, 'day')
}

export function isWithinAcceptableRange(date: moment.Moment) {
    return minDate <= date && date <= maxDate
}

export function compareAndFixPeriod(
    oldStart: string | null, newStart: string | null,
    oldEnd: string | null, newEnd: string | null) {
    let datesError = moment(newStart).isAfter(newEnd)
    let startChanged = oldStart != newStart
    let endChanged = oldEnd != newEnd
    let lastDayOfMonthOfStart = moment(newStart).endOf('month').format(isoDateFormat)
    let firtDayOfMonthOfEnd = moment(newEnd).startOf('month').format(isoDateFormat)

    let start = !startChanged && datesError ? firtDayOfMonthOfEnd : newStart
    let end = !endChanged && datesError ? lastDayOfMonthOfStart : newEnd

    return { start, end }
}

export function formatWithCountryTimezone(date: string, format: string): string {
    if (localStorage.getItem('userCountry') == 'ZA') {
        return moment(date).utcOffset('+0200').format(format)
    } else {
        return moment(date).format(format)
    }
}

export function updateDateTime(newDate, newTime) {
    let dateMoment = moment(newDate)
    let timeMoment = moment(newTime)

    let combinedDateTime = dateMoment.set({
        hour: timeMoment.hour(),
        minute: timeMoment.minute(),
        second: timeMoment.second(),
        millisecond: timeMoment.millisecond()
    })

    return moment(combinedDateTime).format('YYYY-MM-DDTHH:mm:ss')
}